import { Button } from "@mantine/core";
import { useMemo } from "react";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setEditing } from "src/redux/slices/entrySlice";
import { setLandscapeSection } from "src/redux/slices/generatorSlice";
import { StyledTd, StyledTr } from "src/styled";

import { type ILandscapeRow } from "./landscape.types";

interface Props {
  rows: ILandscapeRow[];
  sectionIndex: number;
  subSectionIndex: number;
}
const DeleteDynamicRow = ({ rows, sectionIndex, subSectionIndex }: Props) => {
  const dispatch = useDispatch();
  const { locked, you } = useSelector(state => state.entrySlice);
  const { sections } = useSelector(state => state.generatorSlice.lbentry);
  const columnArray = useMemo(() => {
    const len = Object.values(Object.values(rows[0].items)[0].cols).length;
    return new Array(len).fill(0);
  }, [rows]);

  const handleDelete = (index: number) => {
    const clonedRows = structuredClone(rows);
    clonedRows.forEach(row =>
      Object.values(row.items).forEach(item => {
        const key = Object.keys(item.cols)[index];
        delete item.cols[key];
      }),
    );
    if (!sections?.[sectionIndex]?.subSections?.[subSectionIndex]) return;
    const newSection = {
      ...sections[sectionIndex]?.subSections[subSectionIndex],
      rows: clonedRows,
    };
    dispatch(
      setLandscapeSection({
        sectionIndex,
        subSectionIndex,
        section: newSection as any,
      }),
    );
    dispatch(setEditing(true));
  };

  return (
    <StyledTr>
      <td style={{ visibility: "hidden" }} />
      {!Object.values(rows?.[0]?.items ?? {})[0]?.hidden && (
        <td style={{ visibility: "hidden" }} />
      )}
      {columnArray.map((_, idx) => (
        <StyledTd key={`td-del-${idx}`} center style={{ padding: 5 }}>
          <Button
            onClick={async () => handleDelete(idx)}
            variant="outline"
            style={{ margin: "0 auto" }}
            size="xs"
            color="red"
            disabled={
              (idx === 0 && columnArray.length === 1) || (locked && !you)
            }>
            X
          </Button>
        </StyledTd>
      ))}
    </StyledTr>
  );
};
export default DeleteDynamicRow;
